import axios from "axios";

var RegistrationAttempt = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    post: function (regAttempt) {
        return axios.post(
            Apollo.resolveApiUrl('~/register'),
            regAttempt
        );
    },
};

export default RegistrationAttempt;



// WEBPACK FOOTER //
// ./src/models/RegistrationAttempt.js